<mat-button-toggle
  [checked]="filter.negate"
  (change)="filter.negate = $event.source.checked"
  class="negate"
  [matTooltip]="negateTooltip | async"
  >&not;
</mat-button-toggle>
{{ filter.attribute.DisplayName }}
<mat-form-field subscriptSizing="dynamic">
  <mat-label>
    <language key="FilterbuilderKeywordSelect" defaultValue="Keyword"></language>
  </mat-label>
  <mat-select [(ngModel)]="filter.keyword">
    @for (kw of keywordsFor(filter.attribute); track kw) {
      <mat-option [value]="kw">
        {{ keywordLabel(filter.attribute, kw) | async }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
<div class="searchWord datatype{{ datatypeSwitchString(filter.attribute) }}">
  @switch (datatypeSwitchString(filter.attribute)) {
    @case ('Boolean') {
      <mat-radio-group [(ngModel)]="filter.search">
        <mat-radio-button value="true">
          <language key="FilterbuilderBooleanTrue" defaultValue="True"></language>
        </mat-radio-button>
        <mat-radio-button value="false">
          <language key="FilterbuilderBooleanFalse" defaultValue="False"></language>
        </mat-radio-button>
      </mat-radio-group>
    }
    @case ('String') {
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>
          <language key="FilterbuilderString" defaultValue="Search Text"></language>
        </mat-label>
        <input matInput [(ngModel)]="filter.search" autocomplete="off" />
      </mat-form-field>
    }
    @case ('Integer') {
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>
          <language key="FilterbuilderInteger" defaultValue="Value"></language>
        </mat-label>
        <input matInput type="number" [(ngModel)]="filter.search" step="1" autocomplete="off" />
      </mat-form-field>
    }
    @case ('DateTime') {
      <div>
        @if (filter.dateTimeCase === 'daysAgo' || filter.dateTimeCase === 'daysFromToday') {
          <mat-form-field subscriptSizing="dynamic" style="width: 100px">
            <mat-label>
              <language key="FilterbuilderDateTimeDays" defaultValue="Days"></language>
            </mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="filter.search"
              step="1"
              min="0"
              autocomplete="off"
            />
          </mat-form-field>
        }
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>
            <language key="FilterbuilderDateTimeCase" defaultValue="Date Relation"></language>
          </mat-label>
          <mat-select [(ngModel)]="filter.dateTimeCase">
            <mat-option value="specificDate">
              <language
                key="FilterbuilderDateTimeSpecificDate"
                defaultValue="specific date"
              ></language>
            </mat-option>
            <mat-option value="today">
              <language key="FilterbuilderDateTimeToday" defaultValue="today"></language>
            </mat-option>
            <mat-option value="daysAgo">
              <language key="FilterbuilderDateTimeDaysAgo" defaultValue="days ago"></language>
            </mat-option>
            <mat-option value="daysFromToday">
              <language
                key="FilterbuilderDateTimeDaysFromToday"
                defaultValue="days from today"
              ></language>
            </mat-option>
          </mat-select>
        </mat-form-field>
        @if (filter.dateTimeCase === 'specificDate') {
          <mat-form-field subscriptSizing="dynamic">
            <input
              matInput
              [matDatepicker]="filterDatePicker"
              [(ngModel)]="filter.search"
              placeholder="Choose a date"
            />
            <mat-datepicker-toggle matSuffix [for]="filterDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #filterDatePicker></mat-datepicker>
          </mat-form-field>
        }
      </div>
    }
    @case ('Reference') {
      @if (filter.keyword !== 'LoggedInUser' && filter.keyword !== 'TargetObject') {
        <ctrl-identitypicker-single-forfilter
          [config]="idPickerConfig"
          [editEnabled]="true"
          [freshResource]="false"
          [changeDetection]="true"
          [objectDisplayName]="filter.attribute.DisplayName"
        ></ctrl-identitypicker-single-forfilter>
      }
    }
  }
</div>
